import React from 'react';
import { Modal } from './ui/Modal.js';
import { useDataContext } from '../context/data.js';
import translations from '../constants/translations.json';

const DeleteCardModal = ({ message, isOpen, onConfirm, onClose }) => {
  const { language } = useDataContext();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="text-center p-8 space-y-4">
        <h1 className="font-bold text-base sm:text-lg">{message}</h1>

        <div className="flex flex-col md:flex-row gap-2 justify-center">
          <button
            className="bg-primary hover:bg-secondary text-white font-bold w-full sm:w-auto px-20 py-3 rounded-full transition-colors"
            onClick={onConfirm}
          >
            {translations[language]?.yes}
          </button>
          <button
            className="bg-transparent border border-primary hover:bg-primary text-primary hover:text-white font-bold w-full sm:w-auto px-20 py-3 rounded-full transition-colors"
            onClick={onClose}
          >
            {translations[language]?.cancel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteCardModal;
